module.exports = __webpack_public_path__ + "static/media/step2.bfff5f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/sber/step2.png
// module id = 705
// module chunks = 0